import { call, put } from 'redux-saga/effects';
import { Messages } from '../../../../codegen/Localize';
import { assertUnreachable } from '../../../../ts/helpers/TypescriptHelpers';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { Databases } from '../../../../catalog/resources/Databases';
import { Tables } from '../../../../catalog/resources/Tables';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { SetCertificationAction } from '../../../actions/spaces/SetCertificationAction';
import { CertificationDialogState, getCertificationActionDialogOptions } from '../../../content/CertificationDialog';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { FeatureFlags } from '~src/ts/FeatureFlags';

export function* handleSetCertification(action: SetCertificationAction) {
  try {
    yield call(openCertificationDialog, action);

    const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.item]);
    if (!maybeReloaded) {
      yield put(requestSpaceContents());
    }
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

function setCertification(item: IContentInfo<'database'> | IContentInfo<'table'>, args: CertificationDialogState): Promise<IResult> {
  switch(item.contentType) {
    case 'database': return Databases.setDatabaseCertification({
      certificationNote: args.certificationNote,
      isCertified: args.isCertified,
      id: item.vizportalId
    });
    case 'table': return Tables.setTableCertification({
      certificationNote: args.certificationNote,
      isCertified: args.isCertified,
      id: item.vizportalId
    });
    default: assertUnreachable(item);
  }
}

function getCertificationOrDefault(item: IContentInfo<'database'> | IContentInfo<'table'>): CertificationDialogState {
  return {
    isCertified: item.isCertified || false,
    certificationNote: item.certificationNote || ''
  };
}

export function openCertificationDialog(action: SetCertificationAction) {
  const modalInstance = openReactActionDialog(getCertificationActionDialogOptions({
    initialBodyProps: { useMarkup: FeatureFlags.markupEditingEnabled },
    initialFormData: getCertificationOrDefault(action.item),
    doAction: (formData) => setCertification(action.item, formData)
  }));

  return modalInstance.result;
}
